import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    axios
      .post(
        `${API}/auth/google-session`,
        { session_id: sessionId },
        { withCredentials: true }
      )
      .then(({ data }) => navigate("/admin", { replace: true, state: { user: data } }))
      .catch(() => navigate("/admin", { replace: true }));
  }, [location, navigate]);

  return <div className="min-h-screen bg-ink" />;
}
